import React from 'react';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { ExaminerFunction } from '../../../pages/Assessment/Assessment.types';
import { useStyles } from './Nav.styles';
import useSessionUser from '../../../hooks/useSessionUser';
import { IconButton, Typography } from '@material-ui/core';
import { ViewType } from '../../Assessment/AssesmentPanel.component';
import TooltipOne from '../../TooltipOne/TooltipOne.component';

interface NavProps {
  rgzId: string;
  examinerName: string;
  isFullscreen: boolean;
  prevDisabled?: boolean;
  nextDisabled?: boolean;
  handlePrevClick: () => void;
  handleNextClick: () => void;
  examinerFunction: ExaminerFunction | undefined;
  navigationType: ViewType;
  withoutNavigation?: boolean;
}

export const Nav: React.FC<NavProps> = (props) => {
  const classes = useStyles();
  const { userAssessmentSessionInfo } = useSessionUser();
  const userFunction = userAssessmentSessionInfo.function;

  const isNotExaminer = userFunction !== ExaminerFunction.CZE;
  const tooltipText = props.navigationType === 'cards' ? 'RGZ' : 'zadanie';

  return (
    <div className={classes.navContainer}>
      {!props.isFullscreen ? (
        <>
          {!props.withoutNavigation && (
            <TooltipOne title={props.prevDisabled ? '' : 'Poprzednie ' + tooltipText} placement="top">
              <IconButton
                disableRipple
                className={classes.navIcon}
                onClick={!props.prevDisabled ? props.handlePrevClick : undefined}
                disabled={props.prevDisabled}
              >
                <NavigateBeforeIcon />
              </IconButton>
            </TooltipOne>
          )}
          <Typography
            variant="h1"
            className={[classes.cardId, props.withoutNavigation ? [classes.cardWithoutNavigation] : []]
              .flat()
              .join(' ')}
          >
            {isNotExaminer ? `${props.rgzId} ${props.examinerName}` : props.rgzId}
          </Typography>
          {!props.withoutNavigation && (
            <TooltipOne title={props.nextDisabled ? '' : 'Następne ' + tooltipText} placement="top">
              <IconButton
                disableRipple
                className={classes.navIcon}
                onClick={!props.nextDisabled ? props.handleNextClick : undefined}
                disabled={props.nextDisabled}
              >
                <NavigateNextIcon />
              </IconButton>
            </TooltipOne>
          )}
        </>
      ) : (
        <Typography variant="h1" className={classes.cardId}>
          {props.rgzId}
        </Typography>
      )}
    </div>
  );
};
